export default __webpack_public_path__ + "static/media/ru.fa3ca0b9.svg";